namespace Areas.MyProjects.Projects {
    "use strict";

    var tabItems = Areas.createTabsWithSameController("MyProjects", ["Finance","Dates", "Schedule","Contracts", "NonPlantContracts", "Completed"], "Projects");
    //var tabItems = Areas.createTabsWithSameController("MyProjects", ["Finance", "Dates", "Contracts", "NonPlantContracts", "Completed"], "Projects");

    export function tabInitialized(params: any) {
        return Areas.tabInitialized(tabItems)(params);
    }

 
    export function viewLink(cellElement: any, cellInfo: any) {
        buildCellContent(cellElement,
            () => { return cellInfo.data.accountId; },
            "<a href= '/Account/Profile/View/{placeholder}'>View</a>");
    }

    export function view() {
        gotoSelected("MyProjectsGrid", "/Account/Profile/View/");
    }


    export function onCellPrepared(e: any) {
        if (e.rowType !== "data") {
            return;
        }
        setPifPafAmountBackground(e);
        setCIBAmountBackground(e);
    }

    function setPifPafAmountBackground(e) {
        var isPifPafDataCell = e.column.dataField === "pifpafAmount";

        if (isPifPafDataCell) {
            if (e.data.pifpafBalance < 0) {
                e.cellElement.css("background-color", "yellow");
            } else if (e.data.pifpafAmount < e.data.cibBudgetAmount) {
                e.cellElement.css("background-color", "yellow");
            }
        }
    }

    function setCIBAmountBackground(e) {
        var isCIBDataCell = e.column.dataField === "cibBudgetAmount";

        if (isCIBDataCell) {
            if (e.data.cibBudgetAmount < e.data.pifpafAmount && e.data.pifpafAmount > 1000000) {
                e.cellElement.css("background-color", "#FFA07A");
            } else if (e.data.cibBudgetAmount < e.data.appropriation && e.data.appropriation > 1000000) {
                e.cellElement.css("background-color", "red");
            }
        }
    }
}